import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getAdminUserIsPosting,
    getAdminUserPostSuccess,
    getAdminUsersPostError,
} from '@selectors/adminUsers';
import { upgradeAdminUser } from '@actions/adminUsers';

export default function useUpgradeAdmin(userID: number): UseUpgradeAdminReturn {
    const dispatch = useDispatch();

    const upgradeUser = useCallback(() => {
        dispatch(upgradeAdminUser(userID, { roles: '{5}' }));
    }, [dispatch, userID]);

    const isPosting = useSelector(getAdminUserIsPosting);
    const error = useSelector(getAdminUsersPostError);
    const upgradeSuccess = useSelector(getAdminUserPostSuccess);

    return {
        upgradeUser,
        isPosting,
        error,
        upgradeSuccess,
    };
}

interface UseUpgradeAdminReturn {
    upgradeUser: () => void;
    isPosting: boolean;
    error: string | null;
    upgradeSuccess: boolean;
}
